//
// Copyright (c) 2011-2015 by Curalate, Inc.
//

export enum BULK_ACTIONS_ACTIONS {
  CLEAR_CURRENT_COLLECTION = 'BULK_ACTIONS_ACTIONS/CLEAR_CURRENT_COLLECTION',
  CLEAR_SELECTED_ITEMS = 'BULK_ACTIONS_ACTIONS/CLEAR_SELECTED_ITEMS',
  CLOSE_ACTION_CONFIRMATION_MODAL = 'BULK_ACTIONS_ACTIONS/CLOSE_ACTION_CONFIRMATION_MODAL',
  CLOSE_BULK_ADD_LABELS_MODAL = 'BULK_ACTIONS_ACTIONS/CLOSE_BULK_ADD_LABELS_MODAL',
  DISABLE_BULK_ACTION = 'BULK_ACTIONS_ACTIONS/DISABLE_BULK_ACTION',
  ENABLE_BULK_ACTION = 'BULK_ACTIONS_ACTIONS/ENABLE_BULK_ACTION',
  OPEN_ACTION_CONFIRMATION_MODAL = 'BULK_ACTIONS_ACTIONS/OPEN_ACTION_CONFIRMATION_MODAL',
  OPEN_BULK_ADD_LABELS_MODAL = 'BULK_ACTIONS_ACTIONS/OPEN_BULK_ADD_LABELS_MODAL',
  OPEN_BULK_REMOVE_LABELS_MODAL = 'BULK_ACTIONS_ACTIONS/OPEN_BULK_REMOVE_LABELS_MODAL',
  SELECT_ITEM = 'BULK_ACTIONS_ACTIONS/SELECT_ITEM',
  SELECT_ITEMS = 'BULK_ACTIONS_ACTIONS/SELECT_ITEMS',
  SET_CURRENT_COLLECTION = 'BULK_ACTIONS_ACTIONS/SET_CURRENT_COLLECTION',
  SET_FEATURES = 'BULK_ACTIONS_ACTIONS/SET_FEATURES',
  SET_ITEMS_BULK_ADD_LABELS_MODAL = 'BULK_ACTIONS_ACTIONS/SET_ITEMS_BULK_ADD_LABELS_MODAL',
  SET_ITEM_DETAILS = 'BULK_ACTIONS_ACTIONS/SET_ITEM_DETAILS',
  UNSELECT_ITEM = 'BULK_ACTIONS_ACTIONS/UNSELECT_ITEM',
  UNSELECT_ITEMS = 'BULK_ACTIONS_ACTIONS/UNSELECT_ITEMS',
  RECEIVE_RIGHTS_STATUSES = 'BULK_ACTIONS_ACTIONS/RECEIVE_RIGHTS_STATUSES',
  SET_SELECTED_ITEMS_FOR_CAPTIONS = 'BULK_ACTIONS_ACTIONS/SET_SELECTED_ITEMS_FOR_CAPTIONS',
  CLEAR_SELECTED_ITEMS_FOR_CAPTIONS = 'BULK_ACTIONS/CLEAR_SELECTED_ITEMS_FOR_CAPTIONS',
  SET_CAPTION_TURN_ON_OFF_STATE = 'BULK_ACTIONS/SET_CAPTION_TURN_ON_OFF_STATE',
  SET_IS_VIDEO_ACTION_IN_PROGRESS = 'BULK_ACTIONS_ACTIONS/SET_IS_VIDEO_ACTION_IN_PROGRESS',
  SET_SELECTED_ITEMS_FOR_CONTENT_SOURCE = 'BULK_ACTIONS_ACTIONS/SET_SELECTED_ITEMS_FOR_CONTENT_SOURCE',
}
